import { parse } from 'wellknown';

// Bounds for Belgium.
// First: Southwest coordinates.
// Second: Northeast coordinates.
export const belgiumBounds = [[1.925326, 49.310457], [6.042325, 52.0]];
export const mapboxAccessToken =
  'pk.eyJ1IjoiZGlkbWFwYm94ZnJlZGVyaWsiLCJhIjoiY2l5anZpam5xMDAwbTJ3cG9uNmltdGZjbiJ9.mdNMUO8TwwzpfDviH5SW7Q';
export const locationIqKey = 'pk.744d6b210ccd6520e4c165b174a09244';

export function transformCoords(x, y) {
  const LongRef = 0.076042943;
  const nLamb = 0.7716421928;
  const aCarre = 6378388 ** 2;
  const bLamb = 6378388 * (1 - 1 / 297);
  const eCarre = (aCarre - bLamb ** 2) / aCarre;
  const KLamb = 11565915.812935;
  const eLamb = Math.sqrt(eCarre);
  // const eSur2 = eLamb / 2;
  const Tan1 = (x - 150000.01256) / (5400088.4378 - y);
  const Lambda = LongRef + (1 / nLamb) * (0.000142043 + Math.atan(Tan1));
  const RLamb = Math.sqrt((x - 150000.01256) ** 2 + (5400088.4378 - y) ** 2);

  const TanZDemi = (RLamb / KLamb) ** (1 / nLamb);

  let Lati1 = 2 * Math.atan(TanZDemi);

  const Haut = 0;

  let eSin;
  let Mult1;
  let Mult2;
  let Mult;
  let LatiN;
  let Diff;
  let DLat;
  // let Dh;

  do {
    eSin = eLamb * Math.sin(Lati1);
    Mult1 = 1 - eSin;
    Mult2 = 1 + eSin;
    Mult = (Mult1 / Mult2) ** (eLamb / 2);
    LatiN = Math.PI / 2 - 2 * Math.atan(TanZDemi * Mult);
    Diff = LatiN - Lati1;
    Lati1 = LatiN;
  } while (Math.abs(Diff) > 0.0000000277777);

  const lat = (LatiN * 180) / Math.PI;
  const lng = (Lambda * 180) / Math.PI;

  const Lat = (Math.PI / 180) * lat;
  const Lng = (Math.PI / 180) * lng;

  const SinLat = Math.sin(Lat);
  const SinLng = Math.sin(Lng);
  const CoSinLat = Math.cos(Lat);
  const CoSinLng = Math.cos(Lng);

  const dx = -125.8;
  const dy = 79.9;
  const dz = -100.5;
  const da = -251.0;
  const df = -0.000014192702;

  const LWf = 1 / 297;
  const LWa = 6378388;
  // const LWb = (1 - LWf) * LWa;
  const LWe2 = 2 * LWf - LWf * LWf;
  const Adb = 1 / (1 - LWf);

  const Rn = LWa / Math.sqrt(1 - LWe2 * SinLat * SinLat);
  const Rm = (LWa * (1 - LWe2)) / (1 - LWe2 * Lat * Lat) ** 1.5;

  DLat = -dx * SinLat * CoSinLng - dy * SinLat * SinLng + dz * CoSinLat;
  DLat += (da * (Rn * LWe2 * SinLat * CoSinLat)) / LWa;
  DLat += df * (Rm * Adb + Rn / Adb) * SinLat * CoSinLat;
  DLat /= Rm + Haut;

  const DLng = (-dx * SinLng + dy * CoSinLng) / ((Rn + Haut) * CoSinLat);
  // Dh = dx * CoSinLat * CoSinLng + dy * CoSinLat * SinLng + dz * SinLat;
  // Dh = Dh - (da * LWa) / Rn + (df * Rn * Lat * Lat) / Adb;

  const LatWGS84 = ((Lat + DLat) * 180) / Math.PI;
  const LngWGS84 = ((Lng + DLng) * 180) / Math.PI;

  return {
    0: +LatWGS84.toFixed(6),
    1: +LngWGS84.toFixed(6),
  };
}

export function convertToPolygon(parsed) {
  let coordinates = '';
  let arrayCoordinates = '';
  arrayCoordinates = parsed.coordinates;

  arrayCoordinates.forEach((pairParent, indexParent, arrayParent) => {
    if (arrayParent.length > 1) {
      [coordinates] = pairParent;
    } else {
      coordinates = pairParent;
    }
    coordinates.forEach((pairChild, indexChild, arrayChild) => {
      const conversion = transformCoords(pairChild[0], pairChild[1]);
      arrayChild[indexChild] = [conversion[1], conversion[0]];
    });
    if (arrayParent.length > 1) {
      parsed.coordinates[indexParent] = [coordinates];
    } else {
      parsed.coordinates[indexParent] = coordinates;
    }
  });
  return parsed;
}

export function createGeometry(jsonString) {
  let parsed = '';
  if (jsonString.indexOf('GEOMETRY') !== -1) {
    [parsed] = parse(jsonString).geometries;

    return convertToPolygon(parsed);
  }
  if (jsonString.indexOf('POLYGON') !== -1) {
    if (
      jsonString.indexOf('), (') !== -1 &&
      jsonString.indexOf('MULTIPOLYGON') === -1
    ) {
      jsonString = jsonString.replace('((', '(((');
      jsonString = jsonString.replace('))', ')))');
      jsonString = jsonString.split('), (').join(')), ((');

      parsed = parse(jsonString);
      const locGeometry = convertToPolygon(parsed);

      for (let i = 0; i < locGeometry.coordinates.length; i++) {
        [locGeometry.coordinates[i]] = locGeometry.coordinates[i];
      }
      return locGeometry;
    }
    parsed = parse(jsonString);
    return convertToPolygon(parsed);
  }
  const json = JSON.parse(jsonString);
  return json.geometry;
}

export function createGeoJSONCircle(center, radiusInKm, points) {
  if (!points) {
    points = 128;
  }

  const coords = {
    latitude: center[1],
    longitude: center[0],
  };

  const km = radiusInKm;

  const ret = [];
  const distanceX = km / (111.32 * Math.cos((coords.latitude * Math.PI) / 180));
  const distanceY = km / 110.574;

  let theta;
  let x;
  let y;
  for (let i = 0; i < points; i++) {
    theta = (i / points) * (2 * Math.PI);
    x = distanceX * Math.cos(theta);
    y = distanceY * Math.sin(theta);

    ret.push([coords.longitude + x, coords.latitude + y]);
  }
  ret.push(ret[0]);

  return {
    type: 'geojson',
    data: {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            type: 'Polygon',
            coordinates: [ret],
          },
        },
      ],
    },
  };
}
